module.exports = __webpack_public_path__ + "img/MotorWithVFD.ae958322.png";